import { render, staticRenderFns } from "./FeatureGroupScoring.vue?vue&type=template&id=08e3d5d6"
import script from "./FeatureGroupScoring.vue?vue&type=script&lang=js"
export * from "./FeatureGroupScoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports